module.exports = __webpack_public_path__ + "img/snb_gsnd.bb11b8ab.svg";